/* eslint-disable max-len */
import {
    IconButton, Text, VStack,
} from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { CardLayout } from './card-layout';
import { BannerId } from '../../../stores/banner-store';
import { useBanner } from '../hooks/use-banners';
import { GetProperlyButton } from '../../minimum-standards/components/get-properly-modal';

function ProperlyLinkBanner() {
    const { isDismissed, dismiss } = useBanner(BannerId.ProperlyLink);

    if (isDismissed) {
        return null;
    }

    return (
        <CardLayout gap={2} px={12} bgColor="secondary.500" color="white" pos="relative">
            <IconButton
                onClick={dismiss}
                variant="ghost"
                colorScheme="muted"
                aria-label="Dismiss properly link banner"
                icon={<FaIcon icon={faXmark} />}
                position="absolute"
                size="sm"
                color="muted.400"
                right={1}
                top={1}
                _hover={{
                    color: 'white',
                    bgColor: 'transparent',
                }}
                _active={{
                    bgColor: 'transparent',
                }}
            />
            <CardLayout.Body
                flexDir={['column', 'column', 'row']}
                gap={[4, 6, 8]}
                alignItems={['center', 'center', 'flex-start']}
                w="full"
            >
                <VStack
                    alignItems={['center', 'center', 'start']}
                    textAlign={['center', 'center', 'left']}
                    flex={1}
                >
                    <Text fontSize={['md', 'lg', 'xl']} fontWeight="500" mb={2}>
                        Get Properly on your phone
                    </Text>
                    <Text
                        fontSize={['xs', 'sm', 'md']}
                        color="charcoal.50"
                        maxW={['100%', '100%', '70%']}
                        lineHeight="1.4"
                    >
                        Download Properly today and before you advertise a rental, get your minimum standards assessment done properly by Detector Inspector. Available on iPhone and Android.
                    </Text>
                </VStack>

                <VStack
                    alignItems="center"
                    justifyContent="center"
                    alignSelf="stretch"
                >
                    <GetProperlyButton
                        variant="rounded-solid"
                        colorScheme="primary"
                        size="cta-md"
                        isExternal
                    >
                        Get Properly
                    </GetProperlyButton>
                </VStack>
            </CardLayout.Body>
        </CardLayout>
    );
}

export { ProperlyLinkBanner };
